'use client';

import type React from 'react';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface SearchBarProps {
  language: string;
  placeholder?: string;
}

export default function SearchBar({
  language,
  placeholder = 'Search blog posts...',
}: SearchBarProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      router.push(`/${language}/blog/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex w-full max-w-sm items-center space-x-2">
      <Input
        type="text"
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="flex-1 [&::placeholder]:translate-x-0 [&::placeholder]:translate-y-0 [&::placeholder]:transform-none"
        style={{ display: 'flex', alignItems: 'center' }}
      />
      <Button
        type="submit"
        size="icon"
        aria-label="Search"
        className="bg-blue px-10 hover:bg-blue-600"
      >
        <Search className="h-4 w-4" />
        <span className="sr-only">Search</span>
      </Button>
    </form>
  );
}
